import styles from './NavIcon.module.css';
import Image from 'next/image';

export default function NavIcon() {
  return (
    <a href="/" className={styles.RiveMark}>
      <Image alt="Rive" src="/static/r_logo_white.svg" width={24} height={26} />
    </a>
  );
}
